export default "__VITE_ASSET__e12c90e4__"